import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface WarningData {
  message?: string;
  submessage?: string;
  title?: string;
}
@Component({
  selector: 'app-warning',
  standalone: false,
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.scss']
})
export class WarningComponent {
constructor(
    public dialogRef: MatDialogRef<WarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WarningData
  ) {
   }
onCancel(): void {
    this.dialogRef.close(false);
  }
onConfirm(): void {
    this.dialogRef.close(true);
  }
}